// import your components, fonts, js
import 'fonts/Metropolis-Regular.otf';
import 'fonts/Montserrat-SemiBold.ttf';
import 'styles/main.scss';
import 'fullpage.js/dist/fullpage.css';
import 'ismobilejs/dist/isMobile.min';
import scrollbarWidth from 'scrollbar-width';
import lozad from 'lozad';
import 'simplebar';
import 'simplebar/dist/simplebar.css';
import 'components/header';
import 'components/breadcrumbs';
import 'components/nav';
import 'components/button';
import 'components/form';
import 'components/customSelect';
import 'components/footer';
import 'components/social';
import 'components/news';
import 'components/job';
import 'components/statistics';
import 'components/services';
import 'components/counters';
import 'components/moving-letters';
import 'components/Tabs';
import 'components/fullPage';
import 'components/googleMaps';
import 'components/scroll-animations';
import 'components/accordion';
import 'components/sliders/news-slider';
import 'components/sliders/testimonials-slider';
import 'components/sliders/history-slider';
import 'components/sliders/team-slider';
import 'components/youtube-modal';
import 'components/sliders/vertical-slider';
import 'components/mixitup';
import 'components/expertise-tabs';

// import 'components/foundation';
import 'components/broken-glass-canvas';
import 'components/scroll-down';
// import 'components/Preloader';


// required for ie11 support by default, extract to separate file if you want
import objectFitImages from 'object-fit-images';
import svg4everybody from 'svg4everybody';


document.addEventListener('DOMContentLoaded', () => {
  const sw = scrollbarWidth();
  const observer = lozad('[data-lazy-image]');
  objectFitImages();
  observer.observe();
  svg4everybody();
  if (sw !== 0) {
    const header = document.querySelector('header');
    document.body.style.width = `calc(100vw - ${sw}px)`;
    header.style.width = `calc(100vw - ${sw}px)`;
  }
});
